<nz-card>
  <div nz-row class="button-wrapper" *ngIf="appService.isEngagementActive">
    <button nz-button nzType="primary" nzSize="large" (click)="openCreateActivationChannelModal()">
      <span nz-icon nzType="plus"></span>
      Add New Channel
    </button>
  </div>
  <div nz-col class="activation-channel-content" nzSpan="24">
    <nz-spin nzTip="Loading..." [nzSize]="'large'" [nzSpinning]="isLoading">
      <div class="content">
        <div class="table-content">
          <nz-table
            nzSize="small"
            [nzData]="rowsToDisplay"
            nzTableLayout="fixed"
            nzShowPagination
            nzShowSizeChanger
            [nzLoading]="isLoading"
            [nzFrontPagination]="true"
            [nzTotal]="totalCount!"
            [nzOuterBordered]="true"
            [nzPageSizeOptions]="supportedPageSizes"
            [nzNoResult]="noResultTemplate"
            [nzHideOnSinglePage]="false"
            [nzVirtualItemSize]="11"
            [nzScroll]="{ x: '70rem', y: '30rem' }"
            #borderedTable
            nzBordered
          >
            <thead>
              <tr>
                <th
                  *ngFor="let cell of headers; index as i"
                  nz-resizable
                  [nzSortOrder]="cell.sortOrder"
                  [nzSortFn]="cell.sortFn"
                  [nzSortDirections]="cell.sortDirections"
                  [nzFilterMultiple]="cell.filterMultiple"
                  [nzFilters]="cell.listOfFilter"
                  [nzFilterFn]="cell.filterFn"
                  [nzWidth]="cell.width ?? '8rem'"
                  [nzRight]="cell.right"
                  [nzLeft]="cell.left"
                  class="nfl-form-label"
                  [nzCustomFilter]="i === 0"
                  appResizableColumn
                  [isDynamicTable]="true"
                >
                  {{ cell.name }}
                  <nz-filter-trigger
                    *ngIf="i === 0"
                    [(nzVisible)]="visible"
                    [nzActive]="searchValue!.length > 0"
                    [nzDropdownMenu]="filterMenu"
                  >
                    <span nz-icon nzType="search"></span>
                  </nz-filter-trigger>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of borderedTable.data">
                <td nzEllipsis [nz-tooltip]="data.name">{{ data.name }}</td>
                <td nzEllipsis [nz-tooltip]="data.channelType">{{ data.channelType }}</td>
                <td nzEllipsis [nz-tooltip]="data.description">{{ data.description }}</td>
                <td nzAlign="center">
                  <nz-tag
                    [nzColor]="getConnectionStatusColor(data.connectionStatus)"
                    *ngIf="data.connectionStatus; else blankCellTpl"
                  >
                    {{ data.connectionStatus | titlecase }}
                  </nz-tag>
                </td>
                <td>{{ data.lastModifiedBy || '--' }}</td>
                <td>{{ data.lastModifiedAt | dateTime }}</td>
                <td nzAlign="center" nzRight>
                  <button
                    nz-button
                    nz-dropdown
                    [nzDropdownMenu]="actionMenu"
                    [disabled]="!appService.isEngagementActive"
                    nz-tooltip
                    [nzTooltipTitle]="!appService.isEngagementActive ? 'Engagement is not active' : ''"
                  >
                    <span nz-icon nzType="more"></span>
                  </button>
                  <nz-dropdown-menu #actionMenu="nzDropdownMenu">
                    <ul nz-menu *ngIf="appService.isEngagementActive">
                      <li nz-menu-item *ngIf="canPerformAction(data)" (click)="openUpdateActivationChannelModal(data)">
                        Edit
                      </li>
                      <li nz-menu-item *ngIf="canPerformAction(data)" (click)="openDeleteActivationChannelModal(data)">
                        Delete
                      </li>
                      <li nz-menu-item *ngIf="canPerformAction(data)" (click)="exportAudience(data)">
                        Export Audience
                      </li>
                    </ul>
                  </nz-dropdown-menu>
                </td>
              </tr>
            </tbody>
          </nz-table>
        </div>
      </div>
    </nz-spin>
  </div>

  <ng-template #noResultTemplate let-name>
    <div>
      <span nz-icon nzType="file-sync" nzTheme="outline"></span>
      <p>No records available</p>
    </div>
  </ng-template>

  <ng-template #blankCellTpl>
    <span nz-typography>--</span>
  </ng-template>

  <nz-dropdown-menu #filterMenu="nzDropdownMenu">
    <div class="ant-table-filter-dropdown">
      <div class="search-box">
        <input type="text" nz-input placeholder="Search Channel Name" [(ngModel)]="searchValue" />
        <button nz-button nzSize="small" nzType="primary" (click)="search()" class="search-button">Search</button>
        <button nz-button nzSize="small" (click)="reset()">Reset</button>
      </div>
    </div>
  </nz-dropdown-menu>
</nz-card>
